// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  dataOrder: {},
  dataEquipment: [],
  exist: false,
  docID: ""
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
